import React, { useState, useEffect } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import {  Form} from 'react-bootstrap';
//import { propTypes } from 'react-json-pretty';
import { FaRegFaceSadTear,FaRegFaceSadCry,FaRegFaceRollingEyes,FaRegFaceSmile,FaRegFaceSmileBeam} from 'react-icons/fa6';


const Progetto_valutazione_vettore_riga = (props) => {
//    const [somma, calcola_somma] = useState('');
   const [input, SET_input] = useState();
   const [item, setItem] = useState({ valutazione: "", another: "another" });
   const { valutazione } = item;

    
  useEffect(() => {
//      console.log ('ddddd')

//      console.log (props.lista_voti)
//      console.log (props.indice_passato)
//      console.log (props.lista_voti[props.indice_passato])

      setItem(prevState => ({
        ...prevState,
        valutazione: props.lista_voti[props.indice_passato]
      }));

  
  }, [props.lista_voti, props.indice_passato]);
  

  const Cambiamento_radio = (passato) => {
        SET_input(passato)
  }


  const handleChange = e => {
      e.persist();
      console.log(e.target.value);
  
      setItem(prevState => ({
        ...prevState,
        valutazione: e.target.value
      }));

      props.SET_lista_voti(prevState1 => ({
          ...prevState1,
          [props.indice_passato]: e.target.value
      }));

      console.log(props.lista_voti)
      let tutto_inserito = false
      let arr = ['voto1', 'voto2', 'voto3', 'voto4', 'voto5', 'voto6', 'voto7']
      if (props.lista_voti != undefined) {
        arr.map(function(element, index, array){
            console.log('element ' + element + ' lista_voti ' + props.lista_voti)

            if (!(element in props.lista_voti || element == props.indice_passato)) {tutto_inserito = true} 
        }, 80);
      }
      props.SET_disabled(tutto_inserito)

      console.log('tutto_inserito ' + tutto_inserito)
      
  };



    return (
    <>
      <tr className="align-middle">
      <th>        
      {props.argomento} 
      </th>
      
      <th>
     
        <Form.Check
          value="1"
          type="radio"
          aria-label="radio 1"
          onChange={handleChange}
          checked={valutazione == "1"}
        />
        <FaRegFaceSadCry />

        </th>
        <th>
 

        <Form.Check
          value="2"
          type="radio"
          aria-label="radio 2"
          onChange={handleChange}
          checked={valutazione == "2"}
        />
               <FaRegFaceSadTear />

        </th>
        <th>

        <Form.Check
          value="3"
          type="radio"
          aria-label="radio 2"
          onChange={handleChange}
          checked={valutazione == "3"}
        />
                <FaRegFaceRollingEyes />

        </th>
        <th>
  
        <Form.Check
          value="4"
          type="radio"
          aria-label="radio 2"
          onChange={handleChange}
          checked={valutazione == "4"}
        />
              <FaRegFaceSmile />

        </th>
        <th>

        <Form.Check
          value="5"
          type="radio"
          aria-label="radio 2"
          onChange={handleChange}
          checked={valutazione == "5"}
        />
                <FaRegFaceSmileBeam />

        </th>
     
      </tr>
    </>
    )
}
export default Progetto_valutazione_vettore_riga;